import moment from 'moment';

export function announcementPayloadDataEntries(payload) {
  if (!payload || typeof payload !== 'object' || Array.isArray(payload)) return [];
  const raw = payload.data;
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return [];
  return Object.keys(raw).map((key) => ({ key, value: raw[key] }));
}

export function formatAnnouncementPayloadValue(val) {
  if (val === null || val === undefined) return '';
  if (typeof val === 'object') {
    try {
      return JSON.stringify(val, null, 2);
    } catch (e) {
      return String(val);
    }
  }
  return String(val);
}

export function isAnnouncementPayloadUrl(val) {
  if (val == null) return false;
  const str = String(val).trim();
  return /^https?:\/\//i.test(str) || /^www\./i.test(str);
}

export function announcementPayloadUrlHref(val) {
  const str = String(val).trim();
  if (/^https?:\/\//i.test(str)) return str;
  if (/^www\./i.test(str)) return `https://${str}`;
  return str;
}

export function formatAnnouncementExpires(iso) {
  if (!iso) return '';
  return moment(iso).format('DD/MM/YYYY HH:mm');
}

export function announcementIsExpiredLive(expiresAt, tick = 0) {
  void tick;
  if (!expiresAt) return false;
  return !moment(expiresAt).isAfter(moment());
}

export function announcementExpiryBadgeText(expiresAt, tick = 0) {
  void tick;
  if (!expiresAt) return '';
  const end = moment(expiresAt);
  const now = moment();
  if (!end.isAfter(now)) {
    return 'Hết hạn';
  }
  let sec = Math.max(0, end.diff(now, 'seconds'));
  const d = Math.floor(sec / 86400);
  sec -= d * 86400;
  const h = Math.floor(sec / 3600);
  sec -= h * 3600;
  const m = Math.floor(sec / 60);
  const s = sec % 60;
  const parts = [];
  if (d > 0) parts.push(`${d} ngày`);
  if (h > 0) parts.push(`${h} giờ`);
  if (m > 0) parts.push(`${m} phút`);
  if (parts.length === 0) {
    return `Còn ${s} giây`;
  }
  if (d === 0 && h === 0 && s > 0) {
    parts.push(`${s} giây`);
  }
  return `Còn ${parts.join(' ')}`;
}

export function announcementIsActiveHighlight(item, tick = 0) {
  void tick;
  if (!item || item.is_expired) return false;
  return !!item.expires_at;
}
